import { BookingStepName, BookingStep } from "types/bookingv2/booking";

// Import step components
import SelectTickets from "components/bookingv2/steps/SelectTickets";
import SelectTime from "components/bookingv2/steps/SelectTime";
import SelectDay from "components/bookingv2/steps/SelectDay";
import AddOns from "components/bookingv2/steps/AddOns";
// Checkout is no longer imported from components - it's now a separate page
import SelectSeatWrapper from "components/bookingv2/steps/SelectSeatWrapper";
import Accreditation from "components/bookingv2/steps/Accreditation";
// We'll keep a placeholder component for the CHECKOUT step
import React from "react";

// Simple checkout redirect placeholder component
function CheckoutPlaceholder() {
  return null;
}

/**
 * Configuration for each booking step
 * Maps each booking step name to its corresponding configuration
 * including the title, subtitle, and component to render
 */
export const stepConfigurations: Record<BookingStepName, BookingStep> = {
  [BookingStepName.SELECT_DAY]: {
    name: BookingStepName.SELECT_DAY,
    title: "select_day_title",
    subtitle: "select_day_subtitle",
    component: SelectDay,
  },
  [BookingStepName.SELECT_TIME]: {
    name: BookingStepName.SELECT_TIME,
    title: "select_time_title",
    subtitle: "select_time_subtitle",
    component: SelectTime,
  },
  [BookingStepName.SELECT_TICKETS]: {
    name: BookingStepName.SELECT_TICKETS,
    title: "select_tickets_title",
    subtitle: "select_tickets_subtitle",
    component: SelectTickets,
  },
  [BookingStepName.SELECT_SEAT]: {
    name: BookingStepName.SELECT_SEAT,
    title: "select_seat_title",
    subtitle: "select_seat_subtitle",
    component: SelectSeatWrapper,
  },
  [BookingStepName.ADD_ONS]: {
    name: BookingStepName.ADD_ONS,
    title: "add_ons_title",
    component: AddOns,
  },
  [BookingStepName.ACCREDITATION]: {
    name: BookingStepName.ACCREDITATION,
    title: "accreditation_title",
    component: Accreditation,
  },

  [BookingStepName.CHECKOUT]: {
    name: BookingStepName.CHECKOUT,
    title: "checkout_title",
    // This component will never be rendered because we'll redirect to the checkout page
    component: CheckoutPlaceholder,
  },
};
